import { toNumber } from '@freelancer/utils';
import { SupportFeedbackIsAllowedGetResultAjax } from './support-feedback-is-allowed.backend-model';
import { SupportFeedbackIsAllowed } from './support-feedback-is-allowed.model';

export function transformSupportFeedbackIsAllowed(
  ajaxResult: SupportFeedbackIsAllowedGetResultAjax,
  authUid: string,
): SupportFeedbackIsAllowed {
  return {
    id: toNumber(authUid),
    isAllowed: ajaxResult.is_allowed,
    supportTicketId: ajaxResult.support_ticket_id,
    dateResolved: ajaxResult.date_resolved * 1000,
  };
}
